import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from '@/store/hooks'
import { fetchMyAggregatesAsync } from '@/store/slices/aggregateSlice'

export const useFetchMyAggregates = () => {
  const dispatch = useAppDispatch()

  const aggregate = useAppSelector((store) => store.aggregate.current)
  const objective = useAppSelector((store) => store.aggregate.objective)

  const objectiveWorkflowId = aggregate?.lastObjectiveWorkflow?.id
  const objectiveActivityId = objective?.activity?.id
  const userId = aggregate?.userId

  useEffect(() => {
    if (!objectiveActivityId || !userId) return

    dispatch(
      fetchMyAggregatesAsync({
        objectiveWorkflowId: objectiveWorkflowId!,
        queries: {
          filter: `[["activity.id", "=", "${objectiveActivityId}"]]`,
        },
      }),
    )

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [objectiveActivityId, objectiveWorkflowId, userId])
}
